import { makeStyles } from '@material-ui/core';
import { calculateWidth, rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  addButton: {
    fontSize: vh(2.08),
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: 1,
    },
  },
  bottomRightButtons: {
    justifyContent: 'flex-end',
    maxWidth: '38vw',
  },
  quantityGrid: {
    justifyContent: 'flex-start',
    marginRight: calculateWidth(10).stringValue,
    paddingRight: '2.5vw',
    alignSelf: 'center',
  },
  buttonGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  quantityLabel: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: rem(1.125),
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.3),
      paddingTop: vh(2.9),
    },
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: 0.7,
    textAlign: 'center',
    paddingTop: vh(2.5),
    paddingRight: vw(0.5),
  },
}));
